'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userRatings = require('./user-ratings.html');

var _userRatings2 = _interopRequireDefault(_userRatings);

var _userRatings3 = require('./user-ratings.controller');

var _userRatings4 = _interopRequireDefault(_userRatings3);

require('./user-ratings.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userRatingsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userType: '<',
    onRatingUpdated: '&'
  },
  template: _userRatings2.default,
  controller: _userRatings4.default,
  controllerAs: 'vm'
};

exports.default = userRatingsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-ratings/user-ratings.component.js
 **/